module.exports = __webpack_public_path__ + "b139462db15e33b1b66b1c6d66c16ca8.pdf";